import { axiosInstance } from "../../../api/axiosInstance";
import { FEE_APIS } from "../../../modules/common/api/apis";
import { getAxiosHeaders } from "../../../modules/common/shared/AxiosAPI";
import { Fee } from "../types";

export const getFees = async (admissionNo: string): Promise<Fee[]> => {
  let cHeaders = getAxiosHeaders();
  cHeaders.set("admissionNo", admissionNo);
  const response = await axiosInstance.get(FEE_APIS.GET_FEE_LIST_BY_STUDENTS, { headers: cHeaders });
  return response.data;
};
